
export default (document) => {
  if (typeof document?.exists === 'function') {
    return document?.exists();
  } else {
    return document?.exists === true;
  }
}